import React from "react"
import { firestore } from "../../core"
import { useLives } from "popopo-lib-front/firestore-access"
import { NavLink } from "react-router-dom"
import { User } from "firebase/auth"
import { SpaceKey } from "popopo-msg"
import { Paths } from "../../paths"

export const SpaceLiveList = (props: { firebase: User; spaceKey: SpaceKey }) => {
  const lives = useLives(firestore, props.spaceKey)

  return (
    <>
      <h4>Lives</h4>
      <div>
        <ul className="list-group w-100">
          {lives === "loading" ? (
            <li>
              <i className="fas fa-spin fa-spinner" />
            </li>
          ) : lives.length === 0 ? (
            <li>ライブは1つも存在しません。</li>
          ) : (
            lives.map((live) => (
              <li key={live.id} className="list-group-item">
                <NavLink to={Paths.spaces.space.lives.live.getPath(props.spaceKey, live.id)}>
                  {live.status} {new Date(live.created_at).toLocaleString("ja-JP")}
                </NavLink>
                <span className="ms-1">ID:<code>{live.id}</code></span>
              </li>
            ))
          )}
        </ul>
      </div>
    </>
  )
}
